const config = {
  API_URL: process.env.API_URL,
  OAUTH_URL: process.env.OAUTH_URL,
  OAUTH_CLIENT_ID: process.env.CLIENT_ID,
  DEDICATED: process.env.DEDICATED === 'true',
  KM_API: process.env.KM_API
}

export default config
